import { h } from 'preact';
import { ReactSVG } from 'react-svg';
import { DISPLAY_CARRIER_LOGO } from '@pperform/pp-constants/widgetConfigs';
import { usePTPConfigContext } from 'GlobalConfig.context';
import ENDPOINTS from 'constants/endpoints.constants';
import { addSvgAccessibility } from 'utils/svg.utils';
import { Container } from './CarrierLogo.styles';

interface CarrierLogoProps {
  carrierId: string;
  carrierName?: string;
}

export const CarrierLogo = ({ carrierId, carrierName }: CarrierLogoProps) => {
  const { trackingDetailsBox } = usePTPConfigContext();
  const { carrierLogo, carrierIconBgColor, carrierIconFontColor } =
    trackingDetailsBox;

  if (!carrierLogo.isEnabled) {
    return null;
  }

  const svgUrl = `${ENDPOINTS.PP_SHARED_ASSETS}/logo-carriers/svg-carrier-logos/${carrierId}.svg`;
  const imageUrl = `${ENDPOINTS.PP_SHARED_ASSETS}/logo-carriers/square-logo-carries/${carrierId}.png`;

  const bgColor =
    carrierLogo.type === DISPLAY_CARRIER_LOGO.CARRIER_PTP_CONFIG_COLOR &&
    carrierIconBgColor;

  const fontColor =
    carrierLogo.type === DISPLAY_CARRIER_LOGO.CARRIER_PTP_CONFIG_COLOR &&
    carrierIconFontColor;

  const altText = carrierName ?? '';

  return (
    <Container
      data-testid="carrier-logo-container"
      bgColor={bgColor}
      fontColor={fontColor}
    >
      {carrierLogo.type === DISPLAY_CARRIER_LOGO.CARRIER_ORIGINAL ? (
        <img src={imageUrl} alt={altText} />
      ) : (
        <ReactSVG
          src={svgUrl}
          fallback={() => <img src={svgUrl} alt={altText} />}
          beforeInjection={addSvgAccessibility(altText)}
        />
      )}
    </Container>
  );
};
